import Service from "../../services";

const state = {
  access_token: null,
  access_token_fb: null,
  users: null,
  checkExpiresToken: false,
  image_profile_facebook: "",
};

const mutations = {
  SET_TOKEN(state, data) {
    state.access_token = data.access_token;
    state.users = data.user;
    state.checkExpiresToken = true;
    state.image_profile_facebook = data.image_profile_facebook;
  },
  setAccessTokenFB(state, data) {
    state.access_token_fb = data;
  },
  CLEAR_TOKEN(state) {
    state.access_token = null;
    state.users = [];
    state.image_profile_facebook = "";
  },
};

const actions = {
  login({ commit }, data) {
    return Service.auth.login(data).then((res) => {
      if (res.status === 200) {
        commit("SET_TOKEN", res);
      }
      return res;
    });
  },
  login_facebook({ commit }, data) {
    return Service.auth.login_facebook(data).then((res) => {
      res["image_profile_facebook"] = data.image_profile_facebook;
      commit("SET_TOKEN", res);
    });
  },
  logout({ commit }) {
    return Service.auth.logout().then((res) => {
      window.localStorage.removeItem("vuex");
      // commit('CLEAR_TOKEN');
      return res;
    });
  },
  register({ commit }, data) {
    return Service.auth.register(data).then((res) => {
      return res;
    });
  },
  checkVerifyEmail({ commit }, token) {
    return Service.auth.checkVerifyEmail(token).then((res) => {
      return res;
    });
  },
  forgetPassword({ commit }, data) {
    return Service.auth.forgetPassword(data).then((res) => {
      return res;
    });
  },
  resetPassword({ commit }, data) {
    return Service.auth.resetPassword(data).then((res) => {
      return res;
    });
  },
  checkExpiresToken({ commit }, profile_id) {
    return Service.auth.checkExpiresToken(profile_id).then((res) => {
      // return res;
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
